<template>
  <div class="column is-12">
    <div class="content">
      <h3>{{ $t('settings.campground.checkoutConfig') }}</h3>
      <p>{{ $t('settings.campground.checkoutConfigDescription') }}</p>
    </div>

    <div class="columns">
      <div class="column is-12">
        <div class="columns is-vcentered">
          <div class="column is-6 is-narrow">
            <label class="label">
              {{ $t('settings.campground.input_guests_nationality') }}
            </label>
          </div>
          <div class="column is-4">
            <div class="field">
              <div class="control">
                <span class="select is-fullwidth">
                  <select v-model="inputGuestsNationality">
                    <option value="n">{{ $t('input_types.options.n') }}</option>
                    <option value="o">{{ $t('input_types.options.o') }}</option>
                    <option value="m">{{ $t('input_types.options.m') }}</option>
                  </select>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'CheckoutConfig',
    inject: ['settingsParent'],
    computed: {
        sp() {
            return this.settingsParent;
        },
        inputGuestsNationality: {
            get() {
                return (this.sp.value.checkout_config &&
                    this.sp.value.checkout_config.input_guests_nationality) || 'n';
            },
            set(val) {
                if(!this.sp.value.checkout_config) {
                    this.$set(this.sp.value, 'checkout_config', {});
                }
                this.$set(this.sp.value.checkout_config, 'input_guests_nationality', val);

                // Sicherstellen, dass es auch in owner_frontend_config gesetzt wird, falls das Backend es dort erwartet
                if(!this.sp.value.owner_frontend_config) {
                    this.$set(this.sp.value, 'owner_frontend_config', {});
                }
                if(!this.sp.value.owner_frontend_config.checkout_config) {
                    this.$set(this.sp.value.owner_frontend_config, 'checkout_config', {});
                }
                this.$set(this.sp.value.owner_frontend_config.checkout_config, 'input_guests_nationality', val);
            },
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/CheckoutConfig.vue